












































import { Component, Prop, Mixins } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";

interface AutomationIntervalsForm {
  suspend_interval: number;
  cancel_interval: number;
  close_interval: number;
}

@Component
export default class AutomationIntervalsControl extends Mixins(
  RequestPromises
) {
  // Props
  @Prop({ required: true })
  public value!: AutomationIntervalsForm;

  @Prop({ default: 0 })
  public minValue!: number;

  @Prop({ default: 90 })
  public maxValue!: number;

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Computed

  public get form(): AutomationIntervalsForm {
    return this.value;
  }

  public get i18n() {
    return {
      suspensionIntervalLabel: this.$tc(
        "_sentence.cprod.suspension_interval_label",
        this.form.suspend_interval,
        { days: this.form.suspend_interval }
      ),
      cancellationIntervalLabel: this.$tc(
        "_sentence.cprod.cancellation_interval_label",
        this.form.cancel_interval,
        { days: this.form.cancel_interval }
      ),
      terminationIntervalLabel: this.$tc(
        "_sentence.cprod.termination_interval_label",
        this.form.close_interval,
        { days: this.form.close_interval }
      )
    };
  }
}
